
import React from 'react'
import PropTypes from 'prop-types'

let id = 0;

class TextFormEntry extends React.Component {
  constructor(props) {
    super(props);
    const inputIsRequired = (typeof props.isRequired === 'function') ? props.isRequired(props.name) : props.isRequired;
    this.state = {
      isOpen: !!props.value || inputIsRequired, 
      id: id++
    };
  }

  render() {
    const p = this.props;

    // what are we
    const isNumberInput = p.type === 'number';
    const inputId = `${this.constructor.name}-${id}-${p.name}`;
    const value = p.value || (isNumberInput ? 0 : "");

    const inputIsRequired = (typeof p.isRequired === 'function')
      ? p.isRequired(p.name)
      : p.isRequired;
    const inputIsInvalid = (typeof p.isInvalid === 'function')
      ? p.isInvalid(p.name, value)
      : p.isInvalid;

    // Compute some reasonable defaults
    const autocomplete = p.autocomplete || p.name;
    const placeholder = p.placeholder || p.label;
    
    if (this.state.isOpen) {
      let input;
      if (isNumberInput) {
        input = inputIsRequired
          ? (<input
            type={p.type}
            name={p.name}
            id={inputId}
            value={value}
            onInput={p.onChange}
            className=""
            placeholder={placeholder}
            autoComplete={autocomplete}
            pattern={p.pattern}
            required />)
          : (<input
            type={p.type}
            name={p.name}
            id={inputId}
            value={value}
            onInput={p.onChange}
            className=""
            placeholder={placeholder}
            autoComplete={autocomplete}
            pattern={p.pattern} />);
      } else {
        input = inputIsRequired
          ? (<input
            type={p.type}
            name={p.name}
            id={inputId}
            value={value}
            onChange={p.onChange}
            className=""
            placeholder={placeholder}
            autoComplete={autocomplete}
            pattern={p.pattern}
            required />)
          : (<input
            type={p.type}
            name={p.name}
            id={inputId}
            value={value}
            onChange={p.onChange}
            className=""
            placeholder={placeholder}
            autoComplete={autocomplete}
            pattern={p.pattern} />);
      }

      return (
        <div
          className={`input-container ${inputIsInvalid ? "error" : ""}`}
        >
          
          <div>
            {input}
          </div>
        </div>);
    } else {
      return (
        <div className="form-group">
          <div className='text-sm m-2' onClick={() => this.setState({ isOpen: true })}>
            <a href="" onClick={(e) => e.preventDefault()}><span className='fa fa-regular fa-plus'></span> add {p.label}</a>
          </div>
        </div>
      )
    }
  }
}

TextFormEntry.propTypes = {
 name: PropTypes.string.isRequired,
 label: PropTypes.string.isRequired,
 onChange: PropTypes.func.isRequired,
 type: PropTypes.oneOf(['url', 'tel', 'email', 'search', 'number', 'range', 'datetime-local', 'date', 'time', 'week', 'month', 'color', 'text']),
 autocomplete: PropTypes.string,
 pattern: PropTypes.string,
 placeholder: PropTypes.string
}

TextFormEntry.defaultProps = {
  type: 'text',
  isInvalid: false,
  isRequired: false,
  pattern: '.*'
}

export default TextFormEntry;